<script>
import { merchantComputed } from '@store/helpers'
import dialog2Mixin from "../mixins/dialog2";
import formatDate from '@utils/format-date'
import { nlToBr } from "@utils";

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      applicablePrepaidOrderItem: {} // {title:"深層潔淨", id:"a5401279-34c6-4058-b1f9-cac05bd63cd5"}
    }
  },
  computed: {
    usageRuleText() {
      let usageRuleText = '';

      this.applicablePrepaidOrderItem.prepaid.usageRules.forEach(item => {
        const timeText = () => {
          let timeText = '';

          item.times.forEach(timeItem => {
            if(timeItem.startTime !== '00:00' || timeItem.endTime !== '23:59') {
              timeText += `\n  。${timeItem.startTime} ~ ${timeItem.endTime}`
            }
          });

          return timeText
        };

        if(item.rangeType === 'date') {
          const dateText = `${item.startDate} ~ ${item.endDate}`;

          usageRuleText += `\n▸ ${dateText}${timeText()}`;
        }

        // 00:00 ~ 08:00
        // 07:00 ~ 09:00

        if(item.rangeType === 'week') {
          const weekTextMap = {
            '1': '週一',
            '2': '週二',
            '3': '週三',
            '4': '週四',
            '5': '週五',
            '6': '週六',
            '0': '週日'
          };
          const weekText = item.range.map(week => {
            return weekTextMap[week]
          }).join('、');

          usageRuleText += `\n▸ ${weekText}${timeText()}`;
        }
      });

      return usageRuleText
    },
  },
  methods: {
    nlToBr,
    formatDate
  }
}
</script>
<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    :custom-class="`${ $style.dialogContact } isStyleLogin text-center`"
    width="786px"
    append-to-body
    @closed="$Dialog2MixinOnDestroy"
  >
    <div class="dialogContact__title">包月方案說明</div>
    <p class="text-primary text-center">{{applicablePrepaidOrderItem.prepaid.title}}</p>
    <div class="dialogContact__content">
      <ul class="list-unstyled">
        <li> - 包月方案期限至{{!!applicablePrepaidOrderItem.expiredDate ? formatDate(applicablePrepaidOrderItem.expiredDate, 'yyyy/MM/dd') : '無期限'}}</li>
        <li v-if="!!applicablePrepaidOrderItem.prepaid.usageRules.length"> - 本包月<span class="text-secondary">不適用</span>於
          <span v-html="nlToBr(usageRuleText)"></span>
        </li>
      </ul>
    </div>
  </el-dialog>
</template>
<!-- section style -->
<style lang="scss" module>
.dialogContact {
  :global {
    .dialogContact {
      &__title {
        margin-bottom: 1.5rem;
        font-family:$font-title;
        font-size: 1.125rem;
        font-weight: 600;
        line-height: 1.5;
        color: $color-blue-dark;
      }

      &__content {
        position: relative;
        padding: 1rem;
        background: rgb(216, 224, 229, 0.2);
        border-radius: 20px;
        text-align: center;
        font-size: 0.875rem;
        text-align: left;
        color: $color-gray-1;
        .list-unstyled {
          @include list-unstyled;
        }
      }
    }
  }
}
</style>
